import { EPath } from "@/3514/constants"
import { EStorageServiceType, SessionStorageServiceKeys, StorageService } from "@/services"

const localStorageService: StorageService = new StorageService(EStorageServiceType.Local)
const sessionStorageService: StorageService = new StorageService(EStorageServiceType.Session)

function _handler(): void {
    try {
        localStorageService.clearStorage()
        sessionStorageService.clearStorage()
        sessionStorageService.setItem(SessionStorageServiceKeys.UserLogout(), true)
        window.location.replace(EPath.Login({ isErrorReset: false }))
    } finally {
        void 0
    }
}

function handle401Error(): void {
    setTimeout(_handler, 0)
}

export { handle401Error }
